<template>
   
    <div class="d-flex justify-content-center imgs">
        <div class="align-self-center"> <img src="@/assets/logo.png" alt="" ></div>
    </div>


 
</template>

<script>
import { defineAsyncComponent } from '@vue/runtime-core'
export default {
 components:{
   

 },
 methods:{
    createNewEntry(){
        this.$router.push({name: 'entry', params:{id:'new'}})
    }
 }
}
</script>

<style lang="scss" scoped>
div{
    height: 100%;
}
.imgs{
    

    top: 100px;
    padding-top: 250px;
}
</style>